import { Modal } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Modal as NBModal, ScrollView } from 'native-base';
import { Dimensions } from 'react-native';

import { useRecoilQuery } from '../../../../../../../../../hooks/useRecoilQuery';
import { clubsDetailsQuery } from '../../../../../../../../../store/product/selectors';
import { useClubsAssetContext } from '../../../../../contexts/products/Clubs';

import { ClubsDetailsContent } from './components/ClubsDetailsContent';
import { ClubsDetailsHeader } from './components/ClubsDetailsHeader';

export const ItemDetails = () => {
  const { height } = Dimensions.get('window');

  const { modalOpen, offerSelected, setModalOpen } = useClubsAssetContext();

  const { data, loading, error } = useRecoilQuery(
    clubsDetailsQuery({
      clubId: offerSelected?.clubId,
      accountId: offerSelected?.accountId,
    })
  );

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  if (!offerSelected) {
    return <></>;
  }

  const props = {
    offer: offerSelected,
    details: data,
    onClose: handleCloseModal,
    isLoading: loading,
    error,
  };

  return (
    <Modal isOpen={modalOpen} onClose={handleCloseModal} testId="modal-details">
      <NBModal.Content
        alignItems="center"
        w="full"
        bgColor="neutral.white"
        maxH={{ base: height * 0.75, lg: '80vh' }}
        maxW={{ base: 'full', lg: '909px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}
        padding={{ base: 'inset.xs', lg: 'inset.md' }}
        borderRadius={BoxBorder.heavy}>
        <ScrollView w="full" showsVerticalScrollIndicator={false}>
          <ClubsDetailsHeader {...props} />
          <ClubsDetailsContent {...props} />
        </ScrollView>
      </NBModal.Content>
    </Modal>
  );
};
